var cov_2gu2goxev8 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/compose.ts",
      hash = "7065d10c2f9b63bfbc4e651d492d0ed7baa4138a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/compose.ts",
    statementMap: {
      "0": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 82,
          column: 3
        }
      },
      "1": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 28
        }
      },
      "2": {
        start: {
          line: 81,
          column: 25
        },
        end: {
          line: 81,
          column: 28
        }
      },
      "3": {
        start: {
          line: 83,
          column: 15
        },
        end: {
          line: 83,
          column: 38
        }
      },
      "4": {
        start: {
          line: 84,
          column: 15
        },
        end: {
          line: 84,
          column: 33
        }
      },
      "5": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 85,
          column: 106
        }
      },
      "6": {
        start: {
          line: 85,
          column: 35
        },
        end: {
          line: 85,
          column: 106
        }
      },
      "7": {
        start: {
          line: 85,
          column: 79
        },
        end: {
          line: 85,
          column: 90
        }
      }
    },
    fnMap: {
      "0": {
        name: "compose",
        decl: {
          start: {
            line: 79,
            column: 16
          },
          end: {
            line: 79,
            column: 23
          }
        },
        loc: {
          start: {
            line: 79,
            column: 39
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 79
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 81,
            column: 11
          },
          end: {
            line: 81,
            column: 12
          }
        },
        loc: {
          start: {
            line: 81,
            column: 25
          },
          end: {
            line: 81,
            column: 28
          }
        },
        line: 81
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 85,
            column: 9
          },
          end: {
            line: 85,
            column: 10
          }
        },
        loc: {
          start: {
            line: 85,
            column: 35
          },
          end: {
            line: 85,
            column: 106
          }
        },
        line: 85
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 85,
            column: 52
          },
          end: {
            line: 85,
            column: 53
          }
        },
        loc: {
          start: {
            line: 85,
            column: 79
          },
          end: {
            line: 85,
            column: 90
          }
        },
        line: 85
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        }, {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        }],
        line: 80
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

// type Fn<V, R> = (x: V) => R
// // @ts-expect-error T is an array :troll:
// type Q<T, V> = (...args: T) => V
//
// export function compose<T, V0, V1>(fn1: Fn<V0, V1>, fn0: Q<T, V0>): Q<T, V1>
// export function compose<T, V0, V1, V2>(fn2: Fn<V1, V2>, fn1: Fn<V0, V1>, fn0: Q<T, V0>): Q<T, V2>
// export function compose<T, V0, V1, V2, V3>(fn3: Fn<V2, V3>, fn2: Fn<V1, V2>, fn1: Fn<V0, V1>, fn0: Q<T, V0>): Q<T, V3>
// export function compose<T, V0, V1, V2, V3, V4>(
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V4>
// export function compose<T, V0, V1, V2, V3, V4, V5>(
//   fn5: Fn<V4, V5>,
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V5>
// export function compose<T, V0, V1, V2, V3, V4, V5, V6>(
//   fn6: Fn<V5, V6>,
//   fn5: Fn<V4, V5>,
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V6>
// export function compose<T, V0, V1, V2, V3, V4, V5, V6, V7>(
//   fn7: Fn<V6, V7>,
//   fn6: Fn<V5, V6>,
//   fn5: Fn<V4, V5>,
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V7>
// export function compose<T, V0, V1, V2, V3, V4, V5, V6, V7, V8>(
//   fn8: Fn<V7, V8>,
//   fn7: Fn<V6, V7>,
//   fn6: Fn<V5, V6>,
//   fn5: Fn<V4, V5>,
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V8>
// export function compose<T, V0, V1, V2, V3, V4, V5, V6, V7, V8, V9>(
//   fn9: Fn<V8, V9>,
//   fn8: Fn<V7, V8>,
//   fn7: Fn<V6, V7>,
//   fn6: Fn<V5, V6>,
//   fn5: Fn<V4, V5>,
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V9>
// export function compose<T, V0, V1, V2, V3, V4, V5, V6, V7, V8, V9, V10>(
//   fn10: Fn<V9, V10>,
//   fn9: Fn<V8, V9>,
//   fn8: Fn<V7, V8>,
//   fn7: Fn<V6, V7>,
//   fn6: Fn<V5, V6>,
//   fn5: Fn<V4, V5>,
//   fn4: Fn<V3, V4>,
//   fn3: Fn<V2, V3>,
//   fn2: Fn<V1, V2>,
//   fn1: Fn<V0, V1>,
//   fn0: Q<T, V0>
// ): Q<T, V10>
export function compose() {
  cov_2gu2goxev8.f[0]++;
  cov_2gu2goxev8.s[0]++;

  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    cov_2gu2goxev8.b[0][0]++;
    cov_2gu2goxev8.s[1]++;
    return function (arg) {
      cov_2gu2goxev8.f[1]++;
      cov_2gu2goxev8.s[2]++;
      return arg;
    };
  } else {
    cov_2gu2goxev8.b[0][1]++;
  }

  var last = (cov_2gu2goxev8.s[3]++, funcs[funcs.length - 1]);
  var rest = (cov_2gu2goxev8.s[4]++, funcs.slice(0, -1));
  cov_2gu2goxev8.s[5]++;
  return function () {
    cov_2gu2goxev8.f[2]++;
    cov_2gu2goxev8.s[6]++;
    return rest.reduceRight(function (composed, f) {
      cov_2gu2goxev8.f[3]++;
      cov_2gu2goxev8.s[7]++;
      return f(composed);
    }, last.apply(void 0, arguments));
  };
}